import { extend } from './extend';
export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus[ApprovalStatus["NeedsApproval"] = 1] = "NeedsApproval";
    ApprovalStatus[ApprovalStatus["Approved"] = 2] = "Approved";
    ApprovalStatus[ApprovalStatus["NotRequired"] = 4] = "NotRequired";
    ApprovalStatus[ApprovalStatus["ReadyToApprove"] = 5] = "ReadyToApprove";
    ApprovalStatus[ApprovalStatus["ReadyToReject"] = 6] = "ReadyToReject";
    ApprovalStatus[ApprovalStatus["Rejected"] = 3] = "Rejected";
})(ApprovalStatus || (ApprovalStatus = {}));
const map = new Map([
    [ApprovalStatus.NeedsApproval, { name: 'Needs Approval' }],
    [ApprovalStatus.Approved, { name: 'Approved' }],
    [ApprovalStatus.Rejected, { name: 'Rejected' }],
    [ApprovalStatus.NotRequired, { name: 'Not Required' }],
    [ApprovalStatus.ReadyToApprove, { name: 'Ready To Accept' }],
    [ApprovalStatus.ReadyToReject, { name: 'Ready to Reject' }],
]);
export default {
    ApprovalStatus: extend(map),
};
